module.exports = __webpack_public_path__ + "static/nuts-e702a328da6796a2d48422d8fd9f1e1f.png";